// ------------------------------------
// Formas de pagamento
// ------------------------------------
(function () {
  'use strict';

  // Listas
  const $collapses = $('.payment-accordion');
  const $cardNumber = $('#co-card-number');
  const $cardCVV = $('#co-card-cvv');
  const $cardValidity = $('#co-card-validity');
  const $cardValidityMonth = $('#co-card-validity-month');
  const $cardValidityYear = $('#co-card-validity-year');
  const $cardBrand = $('#co-card-brand');
  const $cardToken = $('#co-card-hash');
  const urlApi = urlBase + 'core/acoes/checkout/parcelamentos.php';
  const $formAddParams = $('.co-add-params');
  const $cardTokenInputsTrigger = $('.card-trigger');
  const $installmentsWrp = $('.installments-wrp');
  const $installments = $('#co-card-installments');
  const $cardName = $('#co-card-name');
  const $cardCPF = $('#co-card-cpf');
  const $cardCustomer = $('#co-card-name');
  let discount = 0;
  let maxInstallments;
  let maxInstallmentsFree;
  let fee;
  let gateway;
  let cardNumber;
  let cardValidityMonth;
  let cardValidityYear;

  // Ao alterar o número do cartão
  $cardNumber.on('change', function () {
    //$installmentsWrp.hide();
    cardNumber = somenteNumeros($cardNumber.val());
    if (cardNumber.length >= 6) {
      getInstallments();
      if (gateway === 'cielo') {
        getCieloCardBin();
      }
    }
  });

  // Ao alterar a validade do cartão
  $cardValidity.on('input', function () {
    if ($(this).val()) {
      const validityArr = $(this).val().split('/');
      cardValidityMonth = validityArr[0] ? validityArr[0] : undefined;
      cardValidityYear = validityArr[1] ? validityArr[1] : undefined;
      if (cardValidityMonth) {
        $cardValidityMonth.val(cardValidityMonth);
      }
      if (cardValidityYear) {
        $cardValidityYear.val('20' + cardValidityYear);
        cardValidityYear = '20' + cardValidityYear;
      }
    }
  });

  // Ao alterar o CPF do titular
  $cardCPF.on('input', function () {
    if ($(this).val()) {
      const docNumber = somenteNumeros($(this).val());
      if ($('#docNumber').length > 0 && docNumber.length > 10) {
        $('#docNumber').val(docNumber).trigger('change');
      }
    }
  });

  // =====================================================
  // Token Flow (Promise-based)
  // =====================================================

  let tokenInFlight = null;

  // util: dispara eventos globais (opcional, mas útil)
  function emitTokenSuccess(payload) {
    $('body').trigger('checkout:cardTokenSuccess', [payload]);
  }
  function emitTokenError(payload) {
    $('body').trigger('checkout:cardTokenError', [payload]);
  }

  // util: centraliza mensagem amigável
  function normalizeErr(err, fallbackMsg) {
    if (!err) return fallbackMsg;
    if (typeof err === 'string') return err;
    return err.message || fallbackMsg;
  }

  // util: valida se método atual é cartão (ajuste conforme seu value real)
  function isCardPaymentSelected() {
    const $input =
      $('.payment-item').length > 0
        ? $('.payment-item input[name="payment_method"]:checked')
        : $('.co-payment-tabs-input[name="payment_method"]:checked');

    const method = $input.val();
    return method === 'credit_card' || method === 'cartao' || method === 'card';
  }

  // função “única” chamada no submit
  function generateCardToken() {
    if (!isCardPaymentSelected()) {
      return Promise.resolve({ skipped: true });
    }

    // se já existe token, reaproveita (você pode optar por sempre regenerar)
    $cardToken.val('');

    // evita 2 chamadas simultâneas
    if (tokenInFlight) return tokenInFlight;

    if (!gateway) throw new Error('Selecione a forma de pagamento para continuar.');

    // Tryplopay não precisa de card token
    if (gateway === 'tryplopay') {
      return Promise.resolve({
        skipped: true,
        gateway: 'tryplopay',
        noTokenRequired: true,
      });
    }
    if (gateway === 'asaas') {
      return Promise.resolve({
        skipped: true,
        gateway: 'asaas',
        noTokenRequired: true,
      });
    }

    disableOrderBtn();

    tokenInFlight = (async () => {
      try {
        let res;

        if (!gateway) return Promise.reject(new Error('Selecione a forma de pagamento para continuar.'));

        if (gateway === 'mercadopago') res = await getMercadoPagoCardToken();
        else if (gateway === 'pagseguroapi') res = await getPagSeguroApiCardToken();
        else if (gateway === 'pagarme') res = await getPagarmeCardToken();
        else if (gateway === 'appmax') res = await getAppmaxCardToken();
        else if (gateway === 'cielo') res = await getCieloCardToken();
        else if (gateway === 'rede') res = await getRedeCardToken();
        else if (gateway === 'abmex') res = await getAbmexCardToken();
        else if (gateway === 'dom') res = await getDomCardToken();
        else if (gateway === 'pagouai') res = await getPagouaiCardToken();
        // else if (gateway === 'iugu') res = await getIuguCardToken();
        else if (gateway === 'getnet') res = await getNetCardToken();
        else throw new Error('Gateway de cartão não suportado.');

        // res deve ter token
        if (!res?.token) throw new Error('Token não retornado.');

        $cardToken.val(res.token);
        emitTokenSuccess(res);
        return res;
      } catch (err) {
        const msg = normalizeErr(err, 'Não foi possível gerar o token do cartão.');
        emitTokenError({ message: msg, error: err });
        throw new Error(msg);
      } finally {
        tokenInFlight = null;
        enableOrderBtn();
      }
    })();

    return tokenInFlight;
  }

  // Expoe o método globalmente
  window.LPQV = window.LPQV || {};
  window.LPQV.payments = window.LPQV.payments || {};
  window.LPQV.payments.generateCardToken = generateCardToken;

  // Invalida o token caso os dados do cartão sejam alterados
  $('.card-trigger').on('input change', function () {
    if ($cardToken.val()) $cardToken.val('');
  });

  // Recarrega as parcelas quando o valor total é alterado
  $installments.on('change-amount', function () {
    // Gateways "normais" (que usam #co-card-number)
    if ($cardNumber.length) {
      cardNumber = somenteNumeros($cardNumber.val());
      if (cardNumber.length >= 6) {
        getInstallments();
      }
      return;
    }
    // Mercado Pago (fields/iframe)
    if (gateway === 'mercadopago' && isCardPaymentSelected()) {
      mpRefreshInstallments();
    }
    // Pagou.ai (fields/iframe)
    if (gateway === 'pagouai' && isCardPaymentSelected()) {
      getInstallmentsPagouAi();
    }
  });

  // Exibe a bandeira do cartão com base no número
  $cardNumber.on('input change', function () {
    showCardFlag(somenteNumeros($cardNumber.val()));
  });
  if ($cardNumber.length > 0) {
    showCardFlag(somenteNumeros($cardNumber.val()));
  }
  function showCardFlag(cardNumber) {
    cardNumber = typeof cardNumber === 'number' ? cardNumber.toString() : cardNumber;
    const cardFlag = getCardFlag(cardNumber);
    if (cardNumber.length > 3 && cardFlag) {
      showCardFlagEl(cardFlag);
    } else {
      hideCardFlagEl();
    }
  }
  function showCardFlagEl(cardFlag) {
    const $cardFlag = $('.co-card-number-flag');
    if ($cardFlag.length > 0) {
      const $cardFlagImg = $cardFlag.find('img');
      const pathFlags = coreAssetsPath + 'img/payment/';
      $cardFlagImg.attr('src', pathFlags + cardFlag + '.png');
      $cardFlag.addClass('active');
    }
  }
  function hideCardFlagEl() {
    const $cardFlag = $('.co-card-number-flag');
    if ($cardFlag.length > 0) {
      const $cardFlagImg = $cardFlag.find('img');
      $cardFlagImg.attr('src', '');
      $cardFlag.removeClass('active');
    }
  }

  // Valida o campo de validade do cartão
  window.Parsley.addValidator('cardvalidity', {
    validateString: function (value) {
      const validity = value.trim().split('/');
      const month = validity[0];
      const year = validity[1];
      const monthNumber = Number(month);
      const yearNumber = Number('20' + year);
      const curMonth = new Date().getMonth() + 1;
      const curYear = new Date().getFullYear();
      const monthCompare = yearNumber === curYear ? curMonth : 1;
      return (
        month &&
        month.length === 2 &&
        monthNumber >= monthCompare &&
        monthNumber <= 12 &&
        year &&
        year.length > 1 &&
        yearNumber >= curYear
      );
    },
    messages: {
      'pt-br': 'Data inválida.',
    },
  });

  // Valida o campo de data de nascimento
  window.Parsley.addValidator('birthdate', {
    validateString: function (value) {
      const curYear = new Date().getFullYear();
      const birthdate = value.trim().split('/');
      const day = Number(birthdate[0]);
      const month = Number(birthdate[1]);
      const year = Number(birthdate[2]);
      return day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= curYear - 18;
    },
    messages: {
      'pt-br': 'Digite uma data válida.',
    },
  });

  // Percorre todas as listas
  $collapses.each(function () {
    // Variáveis
    const $collapse = $(this);
    const $itens = $collapse.children('.collapse-item');
    const $itensTitle = $itens.children('.collapse-title');
    const $itensContent = $itens.children('.collapse-content');
    const $checks = $itens.find('.collapse-title input');
    const $inputsAll = $itens.find(
      '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
    );
    let itemsActive = 0;
    $itens.each(function () {
      const $item = $(this);
      const $content = $item.find('.collapse-content');
      const $check = $item.find('.collapse-title input');
      const $inputs = $item.find(
        '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
      );
      if ($(this).hasClass('active')) {
        itemsActive++;
        disableAll($itens, $itensContent, $checks, $inputsAll);
        activeItem($item, $content, $check, $inputs);
      }
    });

    if (itemsActive === 0) {
      calcCheckout();
    }

    // Evento de click no título do item
    $itensTitle.on('click', function (ev) {
      ev.preventDefault();
      const $item = $(this).parent('.collapse-item');
      const $content = $(this).next('.collapse-content');
      const $check = $item.find('.collapse-title input');
      const $inputs = $item.find(
        '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
      );
      if (!$item.hasClass('active')) {
        disableAll($itens, $itensContent, $checks, $inputsAll);
        activeItem($item, $content, $check, $inputs);
      }
    });
  });

  if (getUrlParam('payment_method') && $('.payment-item').length) {
    $(window).on('load', function () {
      const optsLabel = {
        credit_card: 'payment-item-credit-card',
        pix: 'payment-item-pix',
        ticket: 'payment-item-ticket',
      };
      $('.payment-item.' + optsLabel[getUrlParam('payment_method')] + ' .collapse-title').trigger('click');
      if (!checkoutStepsEnable) {
        smoothScroll($('.payment-item.' + optsLabel[getUrlParam('payment_method')]));
      }
    });
  }

  // Habilita um item
  function activeItem($item, $content, $check, $inputs) {
    $item.addClass('active');
    $('.co-orderbump').trigger('reload-position');
    $content.slideDown();
    $check.prop('checked', true).trigger('change').parsley().validate();
    $inputs.prop('disabled', false);
    $inputs.prop('required', true);
    $inputs.each(function () {
      $(this).parsley().reset();
    });
    handlePayment();
    $installments.prop('disabled', true);
    $installmentsWrp.find('.form-help').show();
  }

  // Desabilita um item
  function disableItem($item, $content, $check, $inputs) {
    $item.removeClass('active');
    $content.slideUp();
    $check.prop('checked', false).trigger('change').parsley().validate();
    $inputs.val('');
    $inputs.prop('disabled', true);
    $inputs.prop('required', false);
    $inputs.each(function () {
      $(this).parsley().reset();
    });
  }

  // Desabilita todos os itens
  function disableAll($itens, $contents, $checks, $inputsAll) {
    $itens.removeClass('active');
    $contents.slideUp();
    $checks.prop('checked', false).trigger('change');
    $inputsAll.val('');
    $inputsAll.prop('disabled', true);
    $inputsAll.prop('required', false);
    $inputsAll.each(function () {
      $(this).parsley().reset();
    });
  }

  // Ao selecionar uma forma de pagamento
  function handlePayment() {
    if ($collapses.length > 0 || $('.co-payment-tabs-input').length > 0) {
      const $input =
        $('.payment-item').length > 0
          ? $('.payment-item input[name="payment_method"]:checked')
          : $('.co-payment-tabs-input[name="payment_method"]:checked');
      const method = $input.val();
      const title = $input.data('title');
      discount = Number($input.data('discount'));
      maxInstallments = $input.data('max-installments') ? Number($input.data('max-installments')) : 0;
      maxInstallmentsFree = $input.data('max-installments-free') ? Number($input.data('max-installments-free')) : 0;
      gateway = $input.data('gateway');
      fee = $input.data('fee');
      if (!checkoutStepsEnable) {
        dispatchPaymentInfo();
      }
      $('body').trigger('change-payment-method', [{ payment_method: method }]);
      saveOption('payment_method', method);
      saveOption('payment_title', title);
      saveOption('payment_discount', discount);
      //saveCheckout('save', {}, calcCheckout);
      calcCheckout();
      if (method === 'credit_card') {
        if ($('#co-cpf').val() && isValidCPF($('#co-cpf').val())) {
          if ($('#co-name').val()) {
            $cardCustomer.val($('#co-name').val()).trigger('change');
          }
          $('#co-card-cpf').val($('#co-cpf').val()).trigger('change');
        }
      }
    }
  }

  // Popula as parcelas
  function populeInstallments(installments) {
    $installments.html('').prop('disabled', false);
    $installments.append(`<option value="" hidden>Selecione</option>`);
    if (installments.length > 0) {
      const saveInstallment = localStorage.getItem('ci_' + cartToken);
      for (let item in installments) {
        if (installments[item].installment <= maxInstallments) {
          let interestFree = installments[item].interestFree;
          if (typeof installments[item].interestFree === 'string' && installments[item].interestFree === 'false') {
            interestFree = false;
          }
          let installmentFreeSufix = '';
          if (interestFree) {
            installmentFreeSufix = installments[item].installment > 1 ? ' sem juros' : ' à vista';
          }
          const selected = saveInstallment == installments[item].installment ? 'selected' : '';
          $installments.append(
            `<option value="${installments[item].installment}" ${selected}>${
              installments[item].installment
            }x de R$ ${formatMoneyBR(installments[item].installment_amount)}${installmentFreeSufix}</option>`,
          );
        }
      }
      if ($installments.val() != '') {
        $installments.parsley().validate();
      }
      //$installmentsWrp.show();
      $installments.prop('disabled', false);
      $installmentsWrp.find('.form-help').hide();
    } else {
      $installments.prop('disabled', true);
      $installmentsWrp.find('.form-help').show();
    }
  }

  // Obtém as parcelas
  function getInstallments() {
    if ($cardNumber.length > 0 && !previewMode) {
      if (cardNumber.length >= 6) {
        $installments.html('').append('<option value="">Aguarde...</option>').prop('disabled', true);
        if (gateway === 'pagseguro') {
          getPagSeguroCardBrand(getPagSeguroInstallments);
        } else if (gateway === 'mercadopago') {
          setMercadoPagoPaymentMethod();
        } else {
          // Realiza a requisição dos dados
          $.getJSON(
            `${urlApi}?gateway=${gateway}&cardNumber=${cardNumber}&maxInstallments=${maxInstallments}&maxInstallmentsFree=${maxInstallmentsFree}&cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}&fee=${fee}&storeId=${baseLanding}&lp_type=${storeModel}`,
            function (installments) {
              if (installments.installments) {
                populeInstallments(installments.installments);
              } else {
                console.log(installments);
                console.log('Não foi possível obter o parcelamento via AJAX.');
              }
            },
          ).fail(function (result) {
            console.log(result);
          });
        }
      }
    }
    if (previewMode) {
      $installments.parsley().reset();
    }
  }

  function getInstallmentsPagouAi() {
    if (isCardPaymentSelected() && !previewMode) {
      $installments.html('').append('<option value="">Aguarde...</option>').prop('disabled', true);
      if (gateway === 'pagseguro') {
        getPagSeguroCardBrand(getPagSeguroInstallments);
      } else if (gateway === 'mercadopago') {
        setMercadoPagoPaymentMethod();
      } else {
        // Realiza a requisição dos dados
        $.getJSON(
          `${urlApi}?gateway=${gateway}&cardNumber=${cardNumber}&maxInstallments=${maxInstallments}&maxInstallmentsFree=${maxInstallmentsFree}&cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}&fee=${fee}&storeId=${baseLanding}&lp_type=${storeModel}`,
          function (installments) {
            if (installments.installments) {
              populeInstallments(installments.installments);
            } else {
              console.log(installments);
              console.log('Não foi possível obter o parcelamento via AJAX.');
            }
          },
        ).fail(function (result) {
          console.log(result);
        });
      }
    }
    if (previewMode) {
      $installments.parsley().reset();
    }
  }

  // Salva o parcelamento para os gateways
  let reqAjaxSaveInstallments = null;
  function saveInstallments(installments) {
    if (reqAjaxSaveInstallments != null) {
      reqAjaxSaveInstallments.abort();
    }
    reqAjaxSaveInstallments = $.ajax({
      type: 'POST',
      url: `${urlApi}?gateway=${gateway}&cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      data: { installments: JSON.stringify(installments) },
    })
      .done(function (result) {
        /* try {
          result = JSON.parse(result);
          if (result.status === 'success') {
            console.log('Parcelamento salvo com sucesso.');
          } else {
            console.log(result);
            console.log('Não foi possível salvar o parcelamento.');
          }
        } catch (error) {
          console.log(result);
          console.log('Não foi possível salvar o parcelamento.');
        } */
      })
      .fail(function (result) {
        if (result.statusText !== 'abort') {
          console.log(result.statusText);
          console.log('Não foi possível salvar o parcelamento.');
        }
      });
  }

  // Valida as informações do cartão
  function validateCardInfos(brand = true) {
    const cardName = $cardName.val();
    const cardCVV = $cardCVV.val();
    const cardBrand = $cardBrand.val();
    if (brand) {
      return (
        cardName != '' &&
        cardNumber &&
        cardNumber.length >= 6 &&
        cardBrand &&
        cardBrand != '' &&
        cardValidityMonth &&
        cardValidityMonth.length === 2 &&
        cardValidityYear &&
        cardValidityYear.length > 1 &&
        cardCVV &&
        cardCVV.length >= 3
      );
    }
    return (
      cardName != '' &&
      cardNumber &&
      cardNumber.length >= 6 &&
      cardValidityMonth &&
      cardValidityMonth.length === 2 &&
      cardValidityYear &&
      cardValidityYear.length > 1 &&
      cardCVV &&
      cardCVV.length >= 3
    );
  }

  // Exibe a mensagem de erro no campo do número do cartão
  function showCardNumberError() {
    $cardNumber.parsley().removeError('card-number-error', {
      updateClass: true,
    });
    $cardNumber.parsley().addError('card-number-error', {
      message: 'Verifique o número do cartão informado.',
      updateClass: true,
    });
  }

  // Oculta a mensagem de erro no campo do número do cartão
  function hideCardNumberError() {
    $cardNumber.parsley().removeError('card-number-error', {
      updateClass: true,
    });
  }

  // ------------------------------------
  // Tabs
  // ------------------------------------
  const $paymentTabs = $('.co-payment-tab');
  const $paymentTabsChecks = $('.co-payment-tabs-input');
  const $paymentTabsContents = $('.co-payment-tabs-content');
  const $paymentTabsInputsAll = $paymentTabsContents.find(
    'input[data-required], select[data-required], textarea[data-required]',
  );
  if ($paymentTabsChecks.length > 0) {
    handleTabPayment();
  }
  $paymentTabs.on('click', function () {
    const flagTab = $(this).data('flag');
    if (flagTab) {
      showCardFlagEl(flagTab.replace('.png', ''));
    }
  });
  $paymentTabsChecks.on('change', handleTabPayment);
  function handleTabPayment() {
    const $inputChecked = $('.co-payment-tabs-input:checked');
    const tabContentID = $inputChecked.attr('id');
    const $tabItem = $('.co-payment-tab[for="' + tabContentID + '"]');
    const $tabContentItem = $('.co-payment-tabs-content[data-tab-content="' + tabContentID + '"]');
    showTabPayment(tabContentID, $tabItem, $tabContentItem);
    if ($inputChecked.length > 0) {
      handlePayment();
    }
  }
  function showTabPayment(tabContentID, $tabItem, $tabContentItem) {
    $paymentTabs.removeClass('active');
    $paymentTabsContents.removeClass('active');
    //$tabItem.addClass('active');
    $tabContentItem.addClass('active');
    $paymentTabsInputsAll.prop('disabled', true);
    $paymentTabsInputsAll.prop('required', false);
    $paymentTabsInputsAll.val('');
    $paymentTabsInputsAll.each(function () {
      $(this).parsley().reset();
    });
    const $contentInputs = $tabContentItem.find('input[data-required], select[data-required], textarea[data-required]');
    $contentInputs.prop('disabled', false);
    $contentInputs.prop('required', true);
    $contentInputs.each(function () {
      $(this).parsley().reset();
    });
  }

  // ------------------------------------
  // Pagseguro Api (Novo)
  // ------------------------------------

  // Gera hash do cartão
  function getPagSeguroApiCardToken() {
    const psaErrorsList = {
      INVALID_NUMBER: 'Número do cartão inválido.',
      INVALID_SECURITY_CODE: 'Código do cartão inválido.',
      INVALID_EXPIRATION_MONTH: 'Mês de validade do cartão inválido.',
      INVALID_EXPIRATION_YEAR: 'Ano de validade do cartão inválido.',
      INVALID_PUBLIC_KEY: 'Chave do PagSeguro inválida!',
      INVALID_HOLDER: 'Nome do titular do cartão inválido.',
    };

    return new Promise((resolve, reject) => {
      try {
        if (!validateCardInfos(false)) {
          return reject(new Error('Preencha os dados do cartão corretamente.'));
        }

        const $keyEl = $('[data-psa-key]');
        const pagseguroPublicKey = $keyEl.length ? $keyEl.data('psa-key') : null;
        if (!pagseguroPublicKey) {
          return reject(new Error('PagSeguro: chave pública não encontrada.'));
        }

        const psaCard = PagSeguro.encryptCard({
          publicKey: pagseguroPublicKey,
          holder: $cardName.val(),
          number: cardNumber,
          expMonth: cardValidityMonth,
          expYear: cardValidityYear,
          securityCode: $cardCVV.val(),
        });

        if (!psaCard.hasErrors && psaCard.encryptedCard) {
          $cardToken.val(psaCard.encryptedCard);
          return resolve({
            token: psaCard.encryptedCard,
            gateway: 'pagseguroapi',
          });
        }

        if (psaCard.errors?.length) {
          const first = psaCard.errors[0];
          const msg = psaErrorsList[first.code] || 'Não foi possível validar os dados do cartão.';
          return reject(new Error(msg));
        }

        return reject(new Error('Não foi possível gerar o token do cartão.'));
      } catch (err) {
        return reject(err);
      }
    });
  }

  // ------------------------------------
  // Mercado Pago
  // ------------------------------------

  // Variáveis
  let mpCardNumberEl;
  let mpExpirationDateEl;
  let mpSecurityCodeEl;
  let mpCurrentBin = null;
  let mpPaymentMethodId = null;

  // Inicia o Mercado Pago
  if (typeof MercadoPago != 'undefined' && !previewMode) {
    initMercadopago();
  }
  function initMercadopago() {
    getMercadoPagoToken();
  }

  // Obtém o token
  function getMercadoPagoToken() {
    const urlSession = urlBase + 'core/acoes/checkout/mercadopago_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        //console.log(result);
        if (result?.mp_token) {
          window.mp = new MercadoPago(result?.mp_token);
          mpCreateCardInputs();
        }
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Cria os campos de cartão
  function mpCreateCardInputs() {
    // Número do cartão
    mpCardNumberEl = mp.fields
      .create('cardNumber', {
        placeholder: '0000 0000 0000 0000',
      })
      .mount('cardNumber');
    mpCardNumberEl.on('focus', function () {
      $('#cardNumber').closest('.mp-field-wrp').addClass('is-focus');
    });
    mpCardNumberEl.on('blur', function () {
      $('#cardNumber').closest('.mp-field-wrp').removeClass('is-focus');
    });
    // Validade
    mpExpirationDateEl = mp.fields
      .create('expirationDate', {
        placeholder: 'MM/AA',
      })
      .mount('expirationDate');
    mpExpirationDateEl.on('focus', function () {
      $('#expirationDate').closest('.mp-field-wrp').addClass('is-focus');
    });
    mpExpirationDateEl.on('blur', function () {
      $('#expirationDate').closest('.mp-field-wrp').removeClass('is-focus');
    });
    // Código CVV
    mpSecurityCodeEl = mp.fields
      .create('securityCode', {
        placeholder: 'CVV',
      })
      .mount('securityCode');
    mpSecurityCodeEl.on('focus', function () {
      $('#securityCode').closest('.mp-field-wrp').addClass('is-focus');
    });
    mpSecurityCodeEl.on('blur', function () {
      $('#securityCode').closest('.mp-field-wrp').removeClass('is-focus');
    });
    $formAddParams.append(
      `<select id="docType" name="docType" type="text" class="form-input-hidden" value="CPF">
        <option value="CPF" selected>CPF</option>
      </select>`,
    );
    $formAddParams.append(
      `<select id="issuer" name="issuer" data-checkout="issuer" class="form-input-hidden"></select>`,
    );
    $formAddParams.append(`<input type="hidden" id="paymentMethodId" name="paymentMethodId">`);
    initMpBinListener();
  }

  // Ao alterar o BIN do cartão
  function initMpBinListener() {
    mpCardNumberEl.on('binChange', function (data) {
      let bin = data && data.bin ? data.bin : null;
      // Limpeza / reset
      if (!bin) {
        mpCurrentBin = null;
        $('#paymentMethodId').val('');
        $cardBrand.val('');
        $('#issuer').html('');
        return;
      }
      // Evita repetir chamadas se o bin não mudou
      if (bin === mpCurrentBin) return;
      mpCurrentBin = bin;

      // Payment Methods
      mp.getPaymentMethods({ bin: bin })
        .then(function (pm) {
          mpPaymentMethodId = pm && pm.results && pm.results[0] ? pm.results[0].id : null;

          if (!mpPaymentMethodId) {
            $('#paymentMethodId').val('');
            $cardBrand.val('');
            $('#issuer').html('');
            return Promise.reject(new Error('paymentMethodId não encontrado'));
          }

          $('#paymentMethodId').val(mpPaymentMethodId);
          $cardBrand.val(mpPaymentMethodId);

          // Issuers
          return mp.getIssuers({ paymentMethodId: mpPaymentMethodId, bin: bin }).then(function (issuers) {
            if (issuers && issuers.length > 0) {
              $('#issuer').append(`<option value="${issuers[0].id}" selected>${issuers[0].name}</option>`);
            }
            return mpPaymentMethodId; // repassa
          });
        })
        .then(function (paymentMethodId) {
          let amount = getTotalCheckout().toString();
          // Installments
          return mp.getInstallments({
            amount: amount,
            bin: bin,
            paymentTypeId: 'credit_card',
          });
        })
        .then(function (installments) {
          var payerCosts =
            installments && installments[0] && installments[0].payer_costs ? installments[0].payer_costs : [];
          console.log(payerCosts);
          // Formata as parcelas para o formato utilizado
          let newInstallments = [];
          for (let i = 0; i < payerCosts.length; i++) {
            let pc = payerCosts[i];
            newInstallments.push({
              installment: pc.installments,
              amount: pc.total_amount,
              interestFree: pc.installment_rate === 0,
              installment_amount: pc.installment_amount,
            });
          }
          saveInstallments(newInstallments);
          populeInstallments(newInstallments);
          // Invalida o token
          if ($cardToken.val()) $cardToken.val('');
        })
        .catch(function (err) {
          console.error('Erro no fluxo BIN/payment:', err);
        });
    });
  }

  function mpRefreshInstallments() {
    // Só roda se MP estiver ativo e já tivermos BIN
    if (gateway !== 'mercadopago') return;
    if (typeof mp === 'undefined') return;
    if (!mpCurrentBin) return; // ainda não detectou bin
    if (!isCardPaymentSelected()) return;

    let amount = getTotalCheckout().toString();

    // Opcional: trava o select enquanto recalcula
    $installments.html('').append('<option value="">Aguarde...</option>').prop('disabled', true);

    return mp
      .getInstallments({
        amount: amount,
        bin: mpCurrentBin,
        paymentTypeId: 'credit_card',
      })
      .then((installments) => {
        const payerCosts = installments?.[0]?.payer_costs || [];
        const newInstallments = payerCosts.map((pc) => ({
          installment: pc.installments,
          amount: pc.total_amount,
          interestFree: pc.installment_rate === 0,
          installment_amount: pc.installment_amount,
        }));
        saveInstallments(newInstallments);
        populeInstallments(newInstallments);
        if ($cardToken.val()) $cardToken.val('');
        return newInstallments;
      })
      .catch((err) => {
        console.error('[MP] erro ao recalcular parcelas:', err);
        // fallback: reabilita select
        $installments.prop('disabled', false);
      });
  }

  // Gera o token do cartão
  /* function getMercadoPagoCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfosMp()) {
        return reject(new Error('Preencha nome do titular e CPF corretamente.'));
      }

      let cardHolderName = $cardCustomer.val();
      let identificationType = $('#docType').val();
      let identificationNumber = somenteNumeros($cardCPF.val());

      if (!cardHolderName || !identificationType || !identificationNumber) {
        return reject(new Error('Dados do pagador incompletos.'));
      }

      mp.fields
        .createCardToken({
          cardholderName: cardHolderName,
          identificationType: identificationType,
          identificationNumber: identificationNumber,
        })
        .then((token) => {
          if (!token?.id) return reject(new Error('Token inválido retornado pelo Mercado Pago.'));
          $cardToken.val(token.id);
          console.log(token);
          resolve({ token: token.id, gateway: 'mercadopago' });
        })
        .catch((err) => {
          reject(new Error('Erro ao gerar token do cartão (Mercado Pago).'));
        });
    });
  } */
  function getMercadoPagoCardToken() {
    return new Promise((resolve, reject) => {
      if (typeof mp === 'undefined') {
        return reject(new Error('Mercado Pago não carregado. Recarregue a página e tente novamente.'));
      }

      let cardHolderName = $cardCustomer.val().trim();
      let identificationType = $('#docType').val();
      let identificationNumber = somenteNumeros($cardCPF.val());

      if (!cardHolderName) {
        return reject(new Error('Informe o nome do titular do cartão.'));
      }
      if (!identificationNumber || !isValidCPF($cardCPF.val())) {
        return reject(new Error('Informe um CPF válido do titular do cartão.'));
      }
      if (!identificationType) {
        return reject(new Error('Dados do pagador incompletos.'));
      }

      mp.fields
        .createCardToken({
          cardholderName: cardHolderName,
          identificationType: identificationType,
          identificationNumber: identificationNumber,
        })
        .then((token) => {
          if (!token?.id) return reject(new Error('Token inválido retornado pelo Mercado Pago.'));
          $cardToken.val(token.id);
          console.log(token);
          resolve({ token: token.id, gateway: 'mercadopago' });
        })
        .catch((err) => {
          reject(new Error('Erro ao gerar token do cartão (Mercado Pago).'));
        });
    });
  }

  // Valida as informações do cartão (Mercado Pago)
  function validateCardInfosMp() {
    const cardName = $cardName.val().trim();
    const cardCPF = $cardCPF.val();
    if (typeof mp === 'undefined') {
      return false;
    }
    if (!cardName) {
      return false;
    }
    if (!isValidCPF(cardCPF)) {
      return false;
    }
    return true;
  }

  // ------------------------------------
  // Pagarme
  // ------------------------------------

  // Inicia o Pagarme
  if ($('#co_payment_method_credit_card').data('gateway') === 'pagarme' && !previewMode) {
    initPagarme();
  }
  function initPagarme() {
    getPagarmeToken();
  }

  // Obtém o token
  function getPagarmeToken() {
    if (typeof pagarme === 'undefined') {
      window.pagarme = {};
    }
    const urlSession = urlBase + 'core/acoes/checkout/pagarme_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        console.log(result);
        pagarme._token = result.token;
        pagarme._version = result.version;
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getPagarmeCardToken() {
    return new Promise((resolve, reject) => {
      const cardNameVal = $cardName.val();
      const cardCVVVal = $cardCVV.val();

      if (
        !cardNumber ||
        !cardNameVal ||
        !cardValidityMonth ||
        !cardValidityYear ||
        !cardCVVVal ||
        cardCVVVal.length < 3
      ) {
        return reject(new Error('Preencha os dados do cartão corretamente.'));
      }

      if (pagarme._version !== 'v5') {
        return reject(new Error('Versão do Pagarme não suportada para tokenização.'));
      }

      const card = {
        number: cardNumber,
        holder_name: cardNameVal,
        exp_month: Number(cardValidityMonth),
        exp_year: Number(cardValidityYear.substring(2)),
        cvv: cardCVVVal,
        label: '',
      };

      const url = urlBase + 'core/acoes/checkout/pagarme_get_card_token.php';

      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api_token: pagarme._token,
          data: { type: 'card', card: card },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res?.token_card) {
            $cardToken.val(res.token_card);
            resolve({ token: res.token_card, gateway: 'pagarme' });
          } else {
            showCardNumberError();
            reject(new Error('Não foi possível tokenizar o cartão (Pagarme).'));
          }
        })
        .catch(() => reject(new Error('Erro ao tokenizar cartão (Pagarme).')));
    });
  }

  // ------------------------------------
  // Appmax
  // ------------------------------------

  // Obtém o token do cartão
  function getAppmaxCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) {
        return reject(new Error('Preencha os dados do cartão corretamente.'));
      }

      const data = {
        name: $cardName.val(),
        number: cardNumber,
        cvv: $cardCVV.val(),
        month: Number(cardValidityMonth),
        year: cardValidityYear.substring(2),
      };

      const url = urlBase + 'core/acoes/checkout/appmax_get_card_token.php';

      $.getJSON(`${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`, data)
        .done(function (result) {
          if (result?.card_token) {
            $cardToken.val(result.card_token);
            resolve({ token: result.card_token, gateway: 'appmax' });
          } else {
            reject(new Error('Por favor, revise os dados do cartão e tente novamente.'));
          }
        })
        .fail(function () {
          reject(new Error('Erro ao gerar token do cartão (Appmax).'));
        });
    });
  }

  // ------------------------------------
  // Cielo
  // ------------------------------------

  // Obtém o token do cartão
  function getCieloCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

      const data = {
        name: $cardName.val(),
        number: cardNumber,
        month: Number(cardValidityMonth),
        year: cardValidityYear,
        customer: $cardCustomer.val(),
        brand: $cardBrand.val(),
      };

      const url = urlBase + 'core/acoes/checkout/cielo_get_card_token.php';

      $.getJSON(`${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`, data)
        .done((result) => {
          if (result?.card_token) {
            $cardToken.val(result.card_token);
            cieloRun3ds()
              .then(() => resolve({ token: result.card_token, gateway: 'cielo' }))
              .catch(reject);
          } else reject(new Error('Não foi possível gerar token do cartão (Cielo).'));
        })
        .fail(() => reject(new Error('Erro ao gerar token do cartão (Cielo).')));
    });
  }

  // Autentica o cartão via 3DS (Braspag MPI), quando habilitado para a loja
  function cieloRun3ds() {
    return new Promise((resolve, reject) => {
      if ($('#active3ds').val() !== 'true' || typeof BP === 'undefined' || !BP.Mpi) {
        return resolve({ skipped: true });
      }

      const url3ds = urlBase + 'core/acoes/checkout/cielo_get_3ds_token.php';

      $.getJSON(`${url3ds}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`)
        .done((result) => {
          let tokenData;
          try {
            tokenData = typeof result.token_3ds === 'string' ? JSON.parse(result.token_3ds) : result.token_3ds;
          } catch (e) {
            tokenData = null;
          }
          if (!tokenData?.AccessToken) {
            return reject(new Error('Não foi possível obter o token de autenticação 3DS.'));
          }

          $('#mpiToken').val(tokenData.AccessToken);

          // Dados do pedido/cartão/comprador exigidos pela validação 3DS (preenche o template de estrutura/cielo_3ds.php)
          $('.bpmpi_ordernumber').val(cartToken);
          $('.bpmpi_totalamount').val(Math.round(getTotalCheckout() * 100));
          $('.bpmpi_installments').val($installments.val() || '1');

          $('.bpmpi_cardnumber').val(cardNumber);
          $('.bpmpi_cardexpirationmonth').val(cardValidityMonth);
          $('.bpmpi_cardexpirationyear').val(cardValidityYear);
          $('.bpmpi_cardcvv').val($cardCVV.val());
          $('.bpmpi_cardbrand').val($cardBrand.val());

          $('.bpmpi_billto_customerid').val(somenteNumeros($cardCPF.val()));
          $('.bpmpi_billto_contactname').val($cardName.val());
          $('.bpmpi_billto_name').val($cardName.val());
          $('.bpmpi_billto_email').val($('#co-email').val());
          $('.bpmpi_billto_phonenumber').val(somenteNumeros($('#co-phone').val()));

          const sameBilling =
            $('[name="same_billing_address"]').is(':checked') || $('[name="same_billing_address"]').length === 0;
          const addrPrefix = sameBilling ? '' : '_billing';
          $('.bpmpi_billto_street1').val($(`[name="address${addrPrefix}"]`).val());
          $('.bpmpi_billto_city').val($(`[name="city${addrPrefix}"]`).val());
          $('.bpmpi_billto_state').val($(`[name="state${addrPrefix}"]`).val());
          $('.bpmpi_billto_zipcode').val(somenteNumeros($(`[name="zipcode${addrPrefix}"]`).val()));

          $('.bpmpi_shipTo_email').val($('#co-email').val());
          $('.bpmpi_shipTo_phonenumber').val(somenteNumeros($('#co-phone').val()));
          $('.bpmpi_shipto_addressee').val($cardName.val());
          $('.bpmpi_shipTo_street1').val($('[name="address"]').val());
          $('.bpmpi_shipTo_city').val($('[name="city"]').val());
          $('.bpmpi_shipTo_state').val($('[name="state"]').val());
          $('.bpmpi_shipto_zipcode').val(somenteNumeros($('[name="zipcode"]').val()));

          BP.Mpi.validate({
            onSuccess: function (response) {
              $('#cavv').val(response.Cavv);
              $('#xid').val(response.Xid);
              $('#eci').val(response.Eci);
              $('#version').val(response.Version);
              $('#referenceId').val(response.ReferenceId);
              resolve({ skipped: false, threeDs: response });
            },
            onError: function () {
              reject(new Error('Não foi possível concluir a autenticação 3DS do cartão.'));
            },
          });
        })
        .fail(() => reject(new Error('Erro ao obter token de autenticação 3DS.')));
    });
  }

  // Detecta a bandeira pelo número do cartão (padrão de nomes da Cielo)
  // Elo e Hipercard precisam vir antes de Visa/Master pois compartilham prefixos
  function detectCardBrand(number) {
    if (/^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/.test(number)) return 'Elo';
    if (/^(606282|3841)/.test(number)) return 'Hipercard';
    if (/^3[47]/.test(number)) return 'Amex';
    if (/^3(0[0-5]|[68])/.test(number)) return 'Diners';
    if (/^35(2[89]|[3-8])/.test(number)) return 'JCB';
    if (/^(6011|65|64[4-9])/.test(number)) return 'Discover';
    if (/^50/.test(number)) return 'Aura';
    if (/^(5[1-5]|2(2[2-9]|[3-6]|7[01]|720))/.test(number)) return 'Master';
    if (/^4/.test(number)) return 'Visa';
    return '';
  }

  // Obtém dados do cartão via BIN
  // A bandeira é detectada localmente e o BIN da Cielo só sobrescreve se retornar algo
  function getCieloCardBin() {
    $cardBrand.val(detectCardBrand(cardNumber));

    const cardBin = cardNumber.substring(0, 6);
    const data = {
      bin: cardBin,
    };
    const url = urlBase + 'core/acoes/checkout/cielo_get_card_bin.php';
    $.getJSON(
      `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      data,
      function (result) {
        if (result?.card_bin?.Provider) {
          $cardBrand.val(result.card_bin.Provider);
        }
        return result;
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // ------------------------------------
  // Rede
  // ------------------------------------

  // Obtém o token do cartão
  function getRedeCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

      const data = {
        name: $cardName.val(),
        number: cardNumber,
        month: Number(cardValidityMonth),
        year: cardValidityYear,
        customer: $cardCustomer.val(),
        brand: $cardBrand.val(),
        cvv: $cardCVV.val(),
      };

      const url = urlBase + 'core/acoes/checkout/rede_get_card_token.php';

      $.getJSON(`${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`, data)
        .done((result) => {
          if (result?.card_token) {
            $cardToken.val(result.card_token);
            resolve({ token: result.card_token, gateway: 'rede' });
          } else reject(new Error('Não foi possível gerar token do cartão (Rede).'));
        })
        .fail(() => reject(new Error('Erro ao gerar token do cartão (Rede).')));
    });
  }

  // ------------------------------------
  // Abmex
  // ------------------------------------

  // Inicia
  if (typeof AbmexPay != 'undefined' && !previewMode) {
    initAbmex();
  }
  function initAbmex() {
    getAbmexToken();
  }

  // Obtém o token da api
  function getAbmexToken() {
    const urlSession = urlBase + 'core/acoes/checkout/abmex_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        //console.log(result);
        if (result.token) {
          AbmexPay.setPublicKey(result.token);
          //AbmexPay.setTestMode(true);
        } else {
          console.log('Não foi possível obter o token de api da Abmex.');
        }
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getAbmexCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

      const data = {
        number: cardNumber,
        holderName: $cardName.val(),
        expMonth: Number(cardValidityMonth),
        expYear: cardValidityYear,
        cvv: $cardCVV.val(),
      };

      AbmexPay.encrypt(data)
        .then((tkn) => {
          if (!tkn) return reject(new Error('Token inválido (Abmex).'));
          $cardToken.val(tkn);
          resolve({ token: tkn, gateway: 'abmex' });
        })
        .catch(() => reject(new Error('Erro ao gerar token do cartão (Abmex).')));
    });
  }

  // ------------------------------------
  // PAGOU AI
  // ------------------------------------

  // Inicia o Pagou ai
  if (typeof Pagou != 'undefined' && !previewMode) {
    initPagouai();
  }
  function initPagouai() {
    getPagouaiToken();
  }

  // Obtém o token
  function getPagouaiToken() {
    const urlSession = urlBase + 'core/acoes/checkout/pagouai_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      console.log(result);
      window.pagouVersion = result.version || 'v1';
      if (pagouVersion === 'v2') {
        //Pagou.setEnvironment('sandbox');
        window.pagouElements = Pagou.elements({
          publicKey: result.token,
          locale: 'pt-BR',
          origin: window.location.origin,
        });
        initPagouaiCard();
      } else {
        Pagou.setPublicKey(result.token);
        //HopyPay.setTestMode(true);
      }
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Inicializa o cartão do Pagou ai (V2)
  function initPagouaiCard() {
    const card = pagouElements.create('card', {
      theme: 'default',
      style: {
        base: {
          fontFamily: 'Arial, Helvetica, sans-serif',
          labelColor: getCSSVar('--font-color'),
          color: getCSSVar('--font-color'),
          backgroundColor: '#ffffff',
          borderRadius: getCSSVar('--input-radius'),
        },
        focus: {
          borderColor: getCSSVar('--primary-color'),
          backgroundColor: '#ffffff',
        },
        invalid: {
          color: getCSSVar('--danger-color'),
          backgroundColor: '#fde1e3',
          borderColor: getCSSVar('--danger-color'),
        },
      },
    });
    card.mount('#pagouai-card');
    card.on('ready', () => {
      enableOrderBtn();
    });
    card.on('change', (event) => {
      /* if (!event.valid) {
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      } */
    });
    card.on('error', (event) => {
      console.log(event.message ?? 'Não foi possível iniciar o campo de cartão.');
      showAlert(
        'Erro',
        'Não foi possível carregar o módulo de cartão de crédito. Por favor, contate o vendedor.',
        'danger',
      );
    });
    getInstallmentsPagouAi();
  }

  // Obtém o token do cartão
  function getPagouaiCardToken() {
    if (window.pagouVersion === 'v1') {
      return new Promise((resolve, reject) => {
        if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

        const data = {
          number: cardNumber,
          holderName: $cardName.val(),
          expMonth: Number(cardValidityMonth),
          expYear: cardValidityYear,
          cvv: $cardCVV.val(),
        };

        Pagou.encrypt(data)
          .then((tkn) => {
            if (!tkn) return reject(new Error('Token inválido (PagouAi).'));
            $cardToken.val(tkn);
            resolve({ token: tkn, gateway: 'pagouai' });
          })
          .catch(() => reject(new Error('Erro ao gerar token do cartão (PagouAi).')));
      });
    } else {
      return new Promise(async (resolve, reject) => {
        try {
          if (!window.pagouElements) {
            return reject(new Error('Pagou.ai não inicializado.'));
          }
          const result = await pagouElements.submit({
            createTransaction: async (tokenData) => {
              const token = tokenData?.token;
              if (!token) {
                throw new Error('Token não retornado pelo Pagou.ai.');
              }
              $cardToken.val(token);
              return {
                id: 'tmp',
                status: 'authorized',
              };
            },
          });
          if (result.status === 'error') {
            return reject(new Error(result.error || 'Erro no pagamento Pagou.ai.'));
          }
          resolve({
            token: $cardToken.val(),
            gateway: 'pagouai',
            raw: result,
          });
        } catch (err) {
          reject(new Error(err.message || 'Erro ao gerar token (Pagou.ai).'));
        }
      });
    }
  }

  // ------------------------------------
  // DOM
  // ------------------------------------

  // Inicia o Dom
  if (typeof DomPagamentos != 'undefined' && !previewMode) {
    initDom();
  }
  function initDom() {
    getDomToken();
  }

  // Obtém o token
  function getDomToken() {
    const urlSession = urlBase + 'core/acoes/checkout/dom_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      console.log(result);
      DomPagamentos.setPublicKey(result.token);
      window.DomVersion = result.version || 2;
      //HopyPay.setTestMode(true);
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getDomCardToken() {
    if (window.DomVersion == 3) {
      return getDomCardTokenV3(); // IMPORTANTE: retornar!
    }

    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

      const data = {
        number: cardNumber,
        holderName: $cardName.val(),
        expMonth: Number(cardValidityMonth),
        expYear: cardValidityYear,
        cvv: $cardCVV.val(),
      };

      DomPagamentos.encrypt(data)
        .then((tkn) => {
          if (!tkn) return reject(new Error('Token inválido (DOM).'));
          $cardToken.val(tkn);
          resolve({ token: tkn, gateway: 'dom' });
        })
        .catch(() => reject(new Error('Erro ao gerar token do cartão (DOM).')));
    });
  }

  // ------------------------------------
  // DOM V3
  // ------------------------------------

  // Inicia o Dom
  if (typeof initTokenCard !== 'undefined' && !previewMode) {
    initDomV3();
  }
  function initDomV3() {
    getDomTokenV3();
  }

  // Obtém o token
  function getDomTokenV3() {
    const urlSession = urlBase + 'core/acoes/checkout/dom_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      //console.log(result);
      window.DomPublicKey = result.token;
      window.DomVersion = 3;
      // Cria o formulário
      $('.checkout-pag').append(`
      <form id="dompag-form" action="#" method="POST">
        <input type="hidden" data-dompag="number">
        <input type="hidden" data-dompag="verification_value">
        <input type="hidden" data-dompag="full_name">
        <input type="hidden" data-dompag="expiration">
        <input type="hidden" data-dompag="document">
        <input type="hidden" data-dompag="phone">
        <input type="hidden" data-dompag="installments">
        <input type="hidden" data-dompag="token-card">
        <input type="hidden" data-dompag="brand-card">
        <input type="hidden" data-dompag="bin-card">
      </form>`);
      $('#form-checkout').append('<input type="hidden" name="card_bin" id="co-card-bin">');
      $('#co-card-installments').on('change', getDomCardTokenV3);
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getDomCardTokenV3() {
    return new Promise((resolve, reject) => {
      if (!(validateCardInfos(false) && $('#co-card-installments').val() && $cardCPF.val() != '')) {
        return reject(new Error('Preencha os dados do cartão, CPF e parcelas.'));
      }

      let data_card = {
        name: $cardName.val(),
        document: somenteNumeros($cardCPF.val()),
        number: cardNumber,
        cvv: $cardCVV.val(),
        month: cardValidityMonth,
        year: cardValidityYear.substring(2),
      };
      let installments = $installments.val() || 1;

      getTokenCard(window.DomPublicKey, data_card, installments, function (data) {
        if (data?.token) {
          $cardToken.val(data.token);
          $cardBrand.val(data.brand);
          $('#co-card-bin').val(data.bin);
          resolve({ token: data.token, gateway: 'dom', raw: data });
        } else {
          reject(new Error(data?.msgError || 'Não foi possível gerar token do cartão (DOM V3).'));
        }
      });
    });
  }

  // ------------------------------------
  // TRYPLOPAY / IUGU
  // ------------------------------------

  // Inicia o Iugu
  /* if (typeof Iugu != 'undefined' && !previewMode) {
    if (window.LPQV.gateways?.tryplopay?.public_key) {
      Iugu.setAccountID(window.LPQV.gateways.tryplopay.public_key);
      console.log(window.LPQV.gateways.tryplopay.public_key);
    }
  }

  // Obtém o token do cartão
  function getIuguCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));

      const cardNameVal = $cardName.val();
      const nameArr = cardNameVal.trim().split(' ');
      const firstName = nameArr[0];
      nameArr.shift();
      const lastName = nameArr.join(' ');

      const cc = Iugu.CreditCard(cardNumber, cardValidityMonth, cardValidityYear, firstName, lastName, $cardCVV.val());

      Iugu.createPaymentToken(cc, function (response) {
        if (response?.errors) {
          reject(new Error('Cartão inválido. Por favor, revise os dados.'));
        } else if (response?.id) {
          $cardToken.val(response.id);
          resolve({ token: response.id, gateway: 'iugu' });
        } else {
          reject(new Error('Não foi possível gerar token do cartão (Iugu).'));
        }
      });
    });
  } */

  // ------------------------------------
  // GETNET
  // ------------------------------------

  // Variáveis
  const getnetApi = `${urlBase}core/acoes/checkout/getnet.php?store_token=${storeToken}&cart_token=${cartToken}`;
  let getnetToken = null;

  // Obtém o token de acesso
  function getnetAuthToken() {
    $.getJSON(`${getnetApi}&acao=auth_token`, function (result) {
      if (result.status === 'success') {
        getnetToken = result.auth_token;
      } else {
        console.log(result);
      }
    }).fail(function (result) {
      console.log(result);
    });
  }
  if ($('#co_payment_method_credit_card').data('gateway') === 'getnet') {
    getnetAuthToken();
  }

  // Obtém o token do cartão
  function getNetCardToken() {
    return new Promise((resolve, reject) => {
      if (!validateCardInfos(false)) return reject(new Error('Preencha os dados do cartão corretamente.'));
      if (!getnetToken) return reject(new Error('Token de autenticação da Getnet não carregado.'));

      let cardData = {
        card_number: cardNumber,
        cardholder_name: $cardName.val(),
        expiration_month: cardValidityMonth,
        expiration_year: cardValidityYear.substring(2),
        card_cvv: $cardCVV.val(),
      };

      cardData = objToQueryString(cardData);

      $.getJSON(`${getnetApi}&acao=card_token&auth_token=${getnetToken}&${cardData}`)
        .done((result) => {
          if (result?.status === 'success' && result?.card_token) {
            $cardToken.val(result.card_token);
            $('#getnet_customer_id').val(result.customer_id || '');
            resolve({
              token: result.card_token,
              gateway: 'getnet',
              raw: result,
            });
          } else {
            reject(new Error('Não foi possível gerar token do cartão (Getnet).'));
          }
        })
        .fail(() => reject(new Error('Erro ao gerar token do cartão (Getnet).')));
    });
  }

  // ------------------------------------
  // CRIPTO
  // ------------------------------------
  if ($('#co_payment_method_cripto').length) {
    // Variáveis
    const $inputCurrencies = $('#extra-input-payment-cripto-moeda');
    const criptoApi = `${urlBase}core/acoes/checkout/nowpayments_currencies.php?store_token=${storeToken}&cart_token=${cartToken}`;
    let sendingCripto = false;
    let alreadyLoaded = false;
    let defaultValues = [];

    // Carrega as opções padrão (Em caso de falha)
    $inputCurrencies.find('option').each(function () {
      const curItem = $(this).attr('value');
      if (curItem) {
        defaultValues.push(curItem);
      }
    });

    // Ao selecionar a forma de pagamento como cripto
    $('body').on('change-payment-method', function (ev, params) {
      const paymentMethod = params.payment_method;
      if (paymentMethod === 'cripto') {
        getCriptoCurrencies();
      }
    });

    // Obtém a lista de moedas
    function getCriptoCurrencies() {
      if (sendingCripto || alreadyLoaded) {
        return false;
      }
      sendingCripto = true;
      disableOrderBtn();
      $inputCurrencies.prop('disabled', true);
      $inputCurrencies.html('<option value="" hidden>Carregando moedas...</option>');
      const criptoAmount = $('#cripto-amount').val();
      $.getJSON(`${criptoApi}&cripto_amount=${criptoAmount}`, function (result) {
        console.log(result);
        sendingCripto = false;
        enableOrderBtn();
        $inputCurrencies.html('');
        if (result.status === 'ok') {
          alreadyLoaded = true;
          populateCurrencies(result.currencies);
        } else {
          populateCurrencies(defaultValues);
        }
      }).fail(function (result) {
        console.log(result);
        sendingCripto = false;
        enableOrderBtn();
        populateCurrencies(defaultValues);
      });
    }

    // Popula a lista de moedas
    function populateCurrencies(currencies) {
      $inputCurrencies.prop('disabled', false);
      $inputCurrencies.html('');
      $inputCurrencies.append(`<option value="" hidden>Selecione</option>`);
      currencies.forEach((currenc) => {
        $inputCurrencies.append(`<option value="${currenc}">${currenc}</option>`);
      });
    }
  }
})();
